import { Component, Input, NgModule, NO_ERRORS_SCHEMA, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { MatNativeDateModule } from '@angular/material/core'
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from "@angular/material/input";
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

// tslint:disable-next-line:no-duplicate-imports
export const MY_FORMATS = {
    parse: {
        dateInput: 'DD MMM YYYY',
    },
    display: {
        dateInput: 'DD MMM YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

@Component({
    selector: 'datepicker',
    templateUrl: './datepicker.component.html',
    providers: [{ provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] }, { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }],
    standalone: false
})
export class DatepickerComponent implements AfterViewInit {
    @Input() placeholder: string;

    @Input() date: string;
    @Input() disabled: boolean = false;
    @Output() dateChange: EventEmitter<any> = new EventEmitter<any>();


    ngAfterViewInit(): void {


    }
    change(event): void {
        this.dateChange.emit(event.value.toISOString())
    }






    constructor() {

        function pad(number) {
            if (number < 10) {
                return '0' + number;
            }
            return number;
        }
        Date.prototype.toISOString = function () {
            return this.getFullYear() +
                '-' + pad(this.getMonth() + 1) +
                '-' + pad(this.getDate()) +
                'T' + pad(this.getHours()) +
                ':' + pad(this.getMinutes()) +
                ':' + pad(this.getSeconds()) +
                '.' + '000';
        };

    }
}

@NgModule({
    imports: [
        MatNativeDateModule, MatDatepickerModule,
        MatFormFieldModule, MatInputModule],
    providers: [
        MatDatepickerModule
    ],
    declarations: [DatepickerComponent],
    exports: [DatepickerComponent],
    schemas: [NO_ERRORS_SCHEMA]
})
export class DatepickerModule { }